const styles = (theme) => ({
  header: {
    fontWeight: 300,
    backgroundColor: theme.color.white,
    boxShadow: 'none',
    height: 60,
    zIndex: 10,
  },

  headerWithTabs: {
    fontSize: 20,
    fontWeight: 300,
    height: 100,
    paddingBottom: 40,
    backgroundColor: theme.color.white,
    boxShadow: 'none',
    zIndex: 10,
  },

  headerWithTitleAndSearch: {
    fontSize: 20,
    fontWeight: 300,
    height: 'auto',
    backgroundColor: theme.color.white,
    boxShadow: 'none',
    zIndex: 10,
  },

  headerTitle: {
    padding: theme.spacing(1.5, 2.5),
    height: '100%',
  },

  customHeaderTitle: {
    padding: theme.spacing(2.5),
    paddingBottom: theme.spacing(1.25),
    textTransform: 'capitalize',
    display: 'block',
  },

  headerBox: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    flex: 1,
    minWidth: 0,
  },

  headerTitleName: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    flex: 1,
    minWidth: 0,
  },

  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },

  icon: {
    marginRight: theme.spacing(0.5),
  },

  divider: {
    width: '100%',
    margin: 0,
  },
  pinContainer: {
    backgroundColor: theme.color.black_05,
    border: '1px solid rgba(0, 0, 0, 0.13)',
    borderRadius: theme.spacing(0.25),
    padding: theme.spacing(0, 1.25),
  },
});

export default styles;
